export default __webpack_public_path__ + "static/media/logo.0bf33b5d.jpg";